import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';
import { Button } from './ui/button';
import { COMPANY_INFO } from '../mock';

export const MobileStickyCTA = () => {
  return (
    <div className="fixed bottom-0 left-0 right-0 md:hidden z-40 bg-black/95 backdrop-blur-md border-t border-white/10 pb-[env(safe-area-inset-bottom)]">
      <div className="flex items-center gap-3 px-4 py-3">
        {/* Anrufen Button (Primary) */}
        <a href={`tel:${COMPANY_INFO.phone}`} className="flex-1">
          <Button className="w-full bg-brand-green hover:bg-brand-green-dark text-white font-semibold text-sm h-12 rounded-xl shadow-lg shadow-brand-green/25">
            <Phone className="w-4 h-4 mr-2" />
            Anrufen
          </Button>
        </a>

        {/* WhatsApp Button (Secondary) */}
        <a 
          href={`https://wa.me/${COMPANY_INFO.whatsapp}`} 
          target="_blank" 
          rel="noopener noreferrer"
          className="flex-1"
        >
          <Button 
            variant="outline" 
            className="w-full border-2 border-white/20 text-white hover:bg-white/10 font-semibold text-sm h-12 rounded-xl"
          >
            <MessageCircle className="w-4 h-4 mr-2" />
            WhatsApp
          </Button>
        </a>
      </div>
    </div>
  );
};